<template>
  <span id="pageLoaded" style="position: fixed; left: 0; top: 0;">&nbsp;</span>
</template>

<script>
export default {
  name: 'Loaded',
};
</script>

<style scoped>

</style>
